import * as _ from 'lodash';

function _paramsFormat(...args:any) {
    var path;
    var params;
    // var basePath = '/api';
    var basePath = '/i/network/api';

    if (args.length === 0) {
        path = basePath;
        params = {};
    }

    if (args.length === 1) {
        if (typeof args[0] === 'string') {
            path = args[0];
            params = {};
        }
        if (typeof args[0] === 'object') {
            path = basePath;
            params = args[0];
        }
    }

    if (args.length === 2) {
        path = args[0];
        params = args[1];
    }
    return [path, params];
}

function _apiUrlMaker(path:any, params:any) {
    params = _.assign({
        Action: '',
        // Version: '2016-03-04',
        // Region: 'cn-shanghai-3'
    }, params);

    var tem:any = [];
    _.forEach(params, (v, k) => {
        if (v && k) {
            tem.push(k + '=' + v);
        }
    });

    params = tem.join('&');
    return `${path}?${params}`;
}

export default function (...args:any) {
    var [path, params] = _paramsFormat(...args);
    return _apiUrlMaker(path, params);
}
